import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';

@Component({
  selector: 'app-team-task-report',
  templateUrl: './team-task-report.component.html',
  styleUrls: ['./team-task-report.component.scss',
  "../../../../../../assets/sass/libs/datatables.scss",],
encapsulation: ViewEncapsulation.None,
})
export class TeamTaskReportComponent implements OnInit {

    @ViewChild(DatatableComponent) table: DatatableComponent;
    searchVal = null
    page = {
      pageNumber: 0,
      offset: 0,
      pageSize: 100,
      totalPages: 0
    };
    // row data
    public rows = [];
    public filterRows = [];
    public ColumnMode = ColumnMode;
    public limitRef = 100;
    selectedValue = ''
    isFilter: boolean = false
    // column header
    public columns = [
      { name: " Name", prop: "name" },
      { name: "Email", prop: "email" },
      { name: "Designation", prop: "designation" },
      { name: "Phone", prop: "phone" },
      { name: "Actions", prop: "actions" },
    ];
  
    // private
    private tempData = [];
    imageUrl = environment.apiUrls.imageUrl;
    user_role: any
    statusList = []
    activeTab =''
    employee_id:any
    isActivated:boolean
    emp_typeList=[];
    typeId=  "6344000d91f6bc691e775faf" 
    @ViewChild('name') inputName;
    selected_type=null
    user_id:any
    total_salary:any
    selected_employee_type:any
    row_id:any
    current_task_model:any
    next_task_model:any
    public editing = {};

    employee_badge_cat_id = '64b124832d735e2b98be9fd7'
    emp_badgeList=[]
    selected_emp_badge=null;
    isBadgeUpdate : boolean =false
    isTaskStatus : boolean = false
    users_list =[]
    selected_user=null
    responsibilities_data:any
    usersList=[]
    selectedHuntingBy = null
    selectedFarmingBy =null
    job_id:any

    guideline_data:any
    
    constructor(public apiService: ApiService,
      public toastr: ToastrService,
      private modalService: NgbModal,
      private session: SessionStorageService,
      private spinner: NgxSpinnerService,private activerouter: ActivatedRoute,
      private route: Router) {
      this.user_role = JSON.parse(localStorage.getItem('user'))
      let setting_data = JSON.parse(localStorage.getItem('setting-record'))
      let key_data = setting_data.filter((item) => item.key == 'Team Report')      
      this.guideline_data = key_data[0]?._id
      this.getEmployeeStatusList()
  
    }
  
    ngOnInit(): void {
      this.selected_employee_type ='all'
      this.activeEmployeeTab('full_time')
      this.getEmployeeBadge()
      this.getEmployeeType()
      this.getUsers()
    }
    getEmployeeType(){
      this.apiService.getTagByTagCatgoryId(this.typeId).subscribe((res:any)=>{
        this.emp_typeList=res.data
        let data ={displayname:'All',_id:'all'}
        this.emp_typeList.push(data)
        this.emp_typeList.reverse()
      })
    } 

  /**
   * inlineEditingUpdate
   *
   * @param event
   * @param cell
   * @param rowIndex
   */
  inlineEditingUpdate(event, cell, rowIndex,id) {
    this.editing[rowIndex + '-' + cell] = false;    
    this.submitTask(event, cell, rowIndex,id)
  }

    submitTask(event, cell, rowIndex,id){
      this.row_id =id

      if(cell ==='current_task'){
        let body={
          current_task:event.target.value,
          task_status:''
        }
        this.apiService.updateEmployee(this.row_id,body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.isTaskStatus = true
            this.rows[rowIndex][cell] = event.target.value;
            this.rows = [...this.rows];
            this.toastr.success('update successfully')
           
            let status = this.statusList.find((item) => item.name == this.activeTab);
            this.apiService.getEmployeeListByStatus(status._id,this.page.pageNumber + 1, this.limitRef).subscribe((res: any) => {
            this.spinner.hide();
            this.rows = res.items
            this.page.totalPages = res.total
            this.total_salary =res.totalsalary
          })

          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
      if(cell ==='next_task'){
        let body={
          next_task:event.target.value
        }
        this.apiService.updateEmployee(this.row_id,body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.rows[rowIndex][cell] = event.target.value;
            this.rows = [...this.rows];
            this.toastr.success('update successfully')

            let status = this.statusList.find((item) => item.name == this.activeTab);
            this.apiService.getEmployeeListByStatus(status._id,this.page.pageNumber + 1, this.limitRef).subscribe((res: any) => {
            this.spinner.hide();
            this.rows = res.items
            this.page.totalPages = res.total
            this.total_salary =res.totalsalary
          })
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
      
    }
    
    getTypeId(event){
      this.selected_employee_type
      if(this.selected_employee_type !=='all'){
        let status = this.statusList.find((item) => item.name == this.activeTab);
        this.apiService.getEmployeeByTypeId(this.selected_employee_type,this.page.pageNumber+1,this.limitRef,status?._id).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.rows=res?.items
            this.page.totalPages= res?.total
          }
        })
      }  
      if(this.selected_employee_type =='all'){
        this.setAndGetEmployeebyStatus()
      }
    }
    activeEmployeeTab(tab) {
      const activetab = tab;
      this.activeTab = tab
      if (activetab !== '') {
        this.route.navigate(
          [],
          { relativeTo: this.activerouter, queryParams: { status: activetab } }
        );
      }
    }
    setAndGetEmployeebyStatus() {
      this.activerouter.queryParams
        .subscribe((params: any) => {
          this.activeTab = params?.status;
          this.getEmployeeList()
        })
    }
    getEmployeeStatusList() {
      this.apiService.getLeadsStatusList("employeestatus").subscribe((res: any) => {
        this.statusList = res.data
        const desiredStatusOrder = ['full_time', 'part_time'];
        this.statusList = this.statusList.filter((status) => desiredStatusOrder.includes(status.name));

        this.statusList.sort((a,b) => {
          const aIndex = desiredStatusOrder.indexOf(a.name)
          const bIndex = desiredStatusOrder.indexOf(b.name)
          return aIndex - bIndex
        })
        this.setAndGetEmployeebyStatus()
      })
    }
    getEmployeeList() {
        this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
        let status = this.statusList.find((item) => item.name == this.activeTab);
        this.apiService.getEmployeeListByStatus(status._id,this.page.pageNumber + 1, this.limitRef).subscribe((res: any) => {
        this.spinner.hide();
        this.rows = res.items
        this.page.totalPages = res.total
        this.total_salary =res.totalsalary
      })
    }
    pageChangeData(page: any) {
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
        let status = this.statusList.find((item) => item.name == this.activeTab);
        this.apiService.getEmployeeListByStatus(status._id,this.page.pageNumber + 1, this.limitRef).subscribe((res: any) => {
        this.rows = res.items
        this.page.totalPages = res.items.total
      })
    }
    getEmployeeSearch(data: any) {
      this.searchVal = data
      if (this.searchVal) {
        this.apiService.getEmployeeSearch(this.searchVal).subscribe((res: any) => {
          if(res.statusCode === 200){
            this.rows = res.data  
            this.page.totalPages = res.data.length      
          }
        })
      }
      else {
        this.setAndGetEmployeebyStatus()
      }
    }
    resetFilter(){
      this.inputName.nativeElement.value = null;
      this.selected_employee_type ='all'
      this.setAndGetEmployeebyStatus()
    }
    setDefaultPassword(id: any, name: string) {
      if (id) {
        this.apiService.changePasswordEnrolment(id).subscribe((res: any) => {
          if (res.isSuccess === true) {
            this.toastr.success(res.message)
            swal.fire({
              title: "Success!",
              text: `${name} your password is combination of name's first 4 letters (capital) and phone number's last 4 digits`,
              icon: "success",
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false,
            });
          }
          else {
            this.toastr.error(res.error)
          }
        })
      }
    }
    copyToClipboard(name: any, phone: any) {
      let n = name.substring(0, 4).toUpperCase();
      let p = phone.substring(6)
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = n + p
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.toastr.info('Password copied')
    }

    deleteEmployee(password) {
      this.apiService.deleteEmployee(this.employee_id,password).subscribe((res: any) => {
        if(res.statusCode === 200){
          swal.fire({
            icon: "success",
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
          this.setAndGetEmployeebyStatus()
        }
        else {
          swal.fire({
            icon: "error",
            title: 'Error!',
            text: `${res.error}`,
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      })
    }
  
    // ================== Delete Alert ========================
     // ================== Delete Alert ========================
     Delete(id: any) {
      this.employee_id = id
      swal.fire({
        text: "Please Enter Password",
        input: 'password',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.deleteEmployee(result.value)
  
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: 'Cancelled',
            text: 'Your file is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      });
    }
  
    updateEmpRole(id, status_id){
  
      let body={
        status:status_id
      }
     if(id){
      this.apiService.updateEmployee(id,body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Employee status update successfully')
          this.setAndGetEmployeebyStatus()
        }
        else{
          this.toastr.error(res.error)
        }
      })
     }
    }
    activateStudent(data){
      var id=data?.user[0]?._id
      this.isActivated = data.user[0]?.is_activated;
      let model = {
        is_activated: this.isActivated ? false : true
      };
      this.apiService.updateEmployee(id,model).subscribe((res: any) => {
        if (res.isSuccess === true) {
          this.toastr.success(res.message)
          this.setAndGetEmployeebyStatus()
        }
        else{
          this.toastr.error(res.error)
        }
      }) 
    }
    getEmployeeBadge(){
      this.apiService.getTagByTagCatgoryId(this.employee_badge_cat_id).subscribe((res:any)=>{
        this.emp_badgeList=res.data
      })
    }
    getBadgeId(event){
      this.selected_emp_badge
    }
    updateBadge(data,id,usersbadge,delBadgeId){
      if(data === 'add'){
        let body={
          emp_badge:this.selected_emp_badge
        }
        this.apiService.updateEmployee(this.user_id,body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('update successfully')
            this.selected_emp_badge=null
            this.modalService.dismissAll()
            this.setAndGetEmployeebyStatus()
  
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
      if(data === 'delete'){
        
        let dataArr=[]
          dataArr = usersbadge
          const idToRemove = delBadgeId;
          const updatedArray = dataArr.filter(obj => obj._id !== idToRemove);
          console.log('dataArr',updatedArray)

        let body={
          emp_badge:updatedArray
        }
        this.apiService.updateEmployee(id,body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('delete successfully')
            this.selected_emp_badge=null
            this.modalService.dismissAll()
            this.setAndGetEmployeebyStatus()
  
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
     
    
    }
    openModal(content,id,userBadge) {
      this.user_id=id
      if(userBadge){
        this.isBadgeUpdate = true
        this.selected_emp_badge = userBadge.map(item=>item._id)
      }
      const modalRef = this.modalService.open(content);
      modalRef.result.then((result) => {
        // console.log(`Modal closed with result: ${result}`);
      }, (reason) => {
        // console.log(`Modal dismissed with reason: ${reason}`);
      });
    }
    getSelectUserId(event: any) {
      this.selected_user
    }
    openModalReportTo(content,usersData, id) {
      this.user_id =id
      this.selected_user = usersData.map(item => item?._id)
     
      const modalRef = this.modalService.open(content);
      modalRef.result.then((result) => {
        // console.log(`Modal closed with result: ${result}`);
      }, (reason) => {
        // console.log(`Modal dismissed with reason: ${reason}`);
      });
    }
    openModalRes(content,data) {
      
      this.responsibilities_data = data
      const modalRef = this.modalService.open(content);
      modalRef.result.then((result) => {
        // console.log(`Modal closed with result: ${result}`);
      }, (reason) => {
        // console.log(`Modal dismissed with reason: ${reason}`);
      });
    }
    updateReportTo(){
      let body={
        report_to : this.selected_user
      }
      this.apiService.updateEmployee(this.user_id,body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('update successfully')
          this.setAndGetEmployeebyStatus()
          this.modalService.dismissAll()
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    submit(){
      let body={
        employeetype : this.selected_type
      }
      this.apiService.updateEmployee(this.user_id,body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Employee type update successfully')
          this.setAndGetEmployeebyStatus()
          this.modalService.dismissAll()
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    updateEmpBadge(id, badge_id){
        let body={
          emp_badge:badge_id
        }
       if(id){
        this.apiService.updateEmployee(id,body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('Employee badge update successfully')
            this.setAndGetEmployeebyStatus()
          }
          else{
            this.toastr.error(res.error)
          }
        })
       }
      }
      getUsers() {
        this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
          this.usersList = res.items
        })
      }
      getHuntId(event: any) {
        this.selectedHuntingBy
       
      }
      getFarmId(event: any) {
        this.selectedFarmingBy
       
      }
      openModalUser(content,jobData,id){
        this.job_id = id
        this.selectedHuntingBy = jobData?.hunting_by?.map(item=>item)
        this.selectedFarmingBy = jobData?.farming_by?.map(item=>item)
        const modalRef = this.modalService.open(content);
        modalRef.result.then((result) => {
          // console.log(`Modal closed with result: ${result}`);
        }, (reason) => {
          // console.log(`Modal dismissed with reason: ${reason}`);
        });
      }
      updateJob(){
        let body ={
          hunting_by: this.selectedHuntingBy,
          farming_by: this.selectedFarmingBy,
        }
        if(this.job_id){
          this.apiService.updateJob(this.job_id,body).subscribe((res:any)=>{
            if(res.statusCode === 200){
              this.toastr.success('update successfull')
              this.modalService.dismissAll()
              this.setAndGetEmployeebyStatus()
            }
            else this.toastr.error(res.error)
          })
        }
      }

  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  }
  
  